import React, { useEffect, useState } from 'react'
import { BodyType } from '@at/design-system-elements'
import { useFilter } from '../../forms/hocs/filter.context.hoc'
import { ScreenReaderOnly } from '../screen-reader-only/screen-reader-only'
import { NewStyledSearchFiltersBodyTypeContainer, StyledBodyTypeSelector } from './search-filters-body-type.style'
import { ShowMoreOptions } from '../search-filters-checkbox/show-more-options'
import { useChannel } from '../../hooks/use-abtest.hook'
import { Channel } from '@at/sauron-platform-core'

const MAX_INITIAL_CHECKBOX_OPTIONS_CAR_VAN_BIKE = 8
const MAX_INITIAL_CHECKBOX_OPTIONS_MOTORHOME = 6

export const SearchFiltersBodyType = () => {
    const { options, selected, title, filterName, onValueChanged } = useFilter()
    const [selectedBodyTypes, setSelectedBodyTypes] = useState<BodyType[]>([])
    const onChange = (bodyTypeValue: BodyType) => {
        const updatedSelectedBodyTypes = selectedBodyTypes.includes(bodyTypeValue)
            ? selectedBodyTypes.filter((value) => value != bodyTypeValue)
            : [...selectedBodyTypes, bodyTypeValue]

        onValueChanged(updatedSelectedBodyTypes)
    }

    useEffect(() => {
        setSelectedBodyTypes(selected as BodyType[])
    }, [selected])

    const channel = useChannel()
    const maxInitialCheckboxOptions =
        channel === Channel.motorhomes
            ? MAX_INITIAL_CHECKBOX_OPTIONS_MOTORHOME
            : MAX_INITIAL_CHECKBOX_OPTIONS_CAR_VAN_BIKE
    const hasMoreOptions = options.length > maxInitialCheckboxOptions
    const shouldShowMoreOptions = selected.some(
        (selectedOption) => options.findIndex((option) => option.value === selectedOption) >= maxInitialCheckboxOptions
    )
    const [showMoreOptions, setShowMoreOptions] = useState(shouldShowMoreOptions)
    const optionsToShow = showMoreOptions ? options : options.slice(0, maxInitialCheckboxOptions)
    const isWithIcon = channel === Channel.vans || channel === Channel.cars

    return (
        <>
            <NewStyledSearchFiltersBodyTypeContainer data-testid={`body-type-selector-container`}>
                {optionsToShow.map((bodyType) => {
                    const count = bodyType.count

                    return (
                        <StyledBodyTypeSelector
                            onChange={() => (count ? onChange(bodyType.value as BodyType) : {})}
                            key={`body-type-checkbox-${bodyType.value}`}
                            name={bodyType.value as BodyType}
                            count={count}
                            selected={selectedBodyTypes.includes(bodyType.value as BodyType)}
                            imageAlt={`Body type ${bodyType.label}`}
                            layout="horizontal"
                            className="body-type-selector"
                            withIcon={isWithIcon}
                        />
                    )
                })}

                {hasMoreOptions && !showMoreOptions ? (
                    <ShowMoreOptions text="More body types" callback={setShowMoreOptions} />
                ) : null}
            </NewStyledSearchFiltersBodyTypeContainer>
            <ScreenReaderOnly id={`${filterName}-error`} description={`Select an option for ${title}`} />
        </>
    )
}
